import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { areEqual } from 'Utils/equalityChecks';

import { DeleteInternalAtmosphericLogModal } from 'Components/RocketDry';

import { deleteRoomAtmosphericLog } from 'Containers/RocketDry/actions';

import { useRocketDryFunctions } from 'Context/RocketDry';

const DeleteInternalAtmosphericLogModalContainer = () => {
  const dispatch = useDispatch();

  const {
    isDeleteInternalAtmosphericLogModalOpen,
    setIsDeleteInternalAtmosphericLogModalOpen,
    selectedAtmosphericLogGroup,
    setSelectedAtmosphericLogGroup,
    setInternalAtmosphericLogDeleted,
  }: any = useRocketDryFunctions();

  const closeModal = useCallback(() => {
    setIsDeleteInternalAtmosphericLogModalOpen(false);
    setSelectedAtmosphericLogGroup(undefined);
  }, []);

  const onDeleteButtonClick = useCallback(async () => {
    if (selectedAtmosphericLogGroup.outlet) {
      await dispatch(deleteRoomAtmosphericLog(selectedAtmosphericLogGroup.outlet.id));
    }
    if (!selectedAtmosphericLogGroup.inlet.emptyEntry) {
      await dispatch(deleteRoomAtmosphericLog(selectedAtmosphericLogGroup.inlet.id));
    }
    setInternalAtmosphericLogDeleted(true);
    closeModal();
  }, [selectedAtmosphericLogGroup]);

  return (
    <DeleteInternalAtmosphericLogModal
      isOpen={isDeleteInternalAtmosphericLogModalOpen}
      atmosphericLogPair={selectedAtmosphericLogGroup}
      closeModal={closeModal}
      onDeleteButtonClick={onDeleteButtonClick}
    />
  );
};

const DeleteInternalAtmosphericLogModalContainerMemo = memo(DeleteInternalAtmosphericLogModalContainer, areEqual);

export { DeleteInternalAtmosphericLogModalContainerMemo as DeleteInternalAtmosphericLogModal };
